<template>
  <div class="row m-0 d-flex justify-content-center">
    <section class="login-form register-form col-md-6 col-xxs-12">
      <b-tabs align="center" fill justified>
        <b-tab :title="$t('register.registerButton')" active>
            <b-card class="register-form--card mx-md-5 mx-xxs-1 ">
          <div class="px-3">
            <span class="gift w-100 d-block">{{ $t('login.oneMonthGift') }}</span>
          </div>
          <RegisterForm />
        <RegisterByGoogle />
        <div class="d-flex justify-content-end px-5 d-xxs-none d-sm-flex d-md-none">
          <b-img :src="portalGeneralInfo.logoWithSubtitleUrl" class="portal-logo" />
        </div>
        </b-card>
        </b-tab>
        <b-tab :title="$t('login.submitLogin')">
            <b-card class="login-form--card mx-md-5 mx-xxs-1">
          <LoginForm />
        <LoginByGoogle />
        </b-card>
        </b-tab>
      </b-tabs>
    </section>
  </div>
</template>

<script>
  import LoginForm from '@/components/LoginForm.vue'
  import LoginByGoogle from '@/components/LoginByGoogle.vue'
  import RegisterForm from '@/components/RegisterForm.vue'
  import RegisterByGoogle from '@/components/RegisterByGoogle'
  import { mapGetters, mapActions } from 'vuex'

  export default {
    name: 'LoginRegisterDesktop',
    components: {
      LoginForm,
      LoginByGoogle,
      RegisterForm,
      RegisterByGoogle
    },
    computed: {
      ...mapGetters({
        portalConfigurations: 'tenantDesign/config',
      }),
      portalGeneralInfo() {
        return this.portalConfigurations.general
      }
    },
  }
</script>

